import { sharedSelectionController } from 'components/SelectionController/SelectionController';

export interface IHasSelection {
  actionHandleItemClick({ item, event }): void;
  actionHandleContextMenu({ item, event }): void;
}

const HasSelection = {
  actionHandleItemClick({ item, event }) {
    sharedSelectionController.handleItemClick({ item, event });
  },

  actionHandleContextMenu({ item, event }) {
    sharedSelectionController.handleContextMenu({ item, event });
  },
};

export default HasSelection;
